import styled from "styled-components";
import Boton from "../Boton";
import { colorSecundario, fondo } from "../UI/variables";
import logo from "../../assets/logo/logoMarca.png";
import { Link } from "react-router-dom";

const StyledHeader = styled.header`
  background-color: ${fondo};
  width: 100vw;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 3px solid ${colorSecundario};
  position: fixed;
  z-index: 1000;
`;
const BoxBoton = styled.div`
  display: flex;
`;

const Logo = styled.img`
  width: 136px;
  height: 48px;
  margin: 16px;
`;

const BotonEstilizado = styled(Boton)`
  border: 1px solid white;
  margin: 8px;
`;

const HeaderOwner = () => {
  return (
    <StyledHeader>
      <Link to="/">
        <Logo src={logo} alt="Logo de Arkilados"/>
      </Link>
      <BoxBoton>
        <BotonEstilizado to="/SignIn">Iniciar Sesión</BotonEstilizado>;
      </BoxBoton>
    </StyledHeader>
  );
};

export default HeaderOwner;
